import {
  faCheck,
  faEye,
  faPen,
  faTrash,
} from "@fortawesome/sharp-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { documentTypeDisplayValueMap } from "./types/document";

import styles from "./uploaded-additional-document.module.scss";
import { AppealSupportingDocumentType } from "@/__generated__/graphql.ts";
import { MeatballMenu } from "@/components/menus/meatball-menu";

type UploadedAdditionalDocumentProps = {
  type: AppealSupportingDocumentType | string;
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
  index?: number;
  readOnly?: boolean;
};

const letterOfMedicalNecessityDescription =
  "Add a copy of a Letter of Medical Necessity from your healthcare provider to the appendix of your appeal.";
const documentDescription = "Added as an appendix item in appeal package.";

export const UploadedAdditionalDocument = ({
  type,
  onView,
  onEdit,
  onDelete,
  index,
  readOnly = false,
}: UploadedAdditionalDocumentProps) => {
  const documentTitle = `${documentTypeDisplayValueMap[type as AppealSupportingDocumentType] ?? type}${index ? ` (${index + 1})` : ""}`;

  const actions = [];

  if (!readOnly) {
    actions.push({
      label: "Edit",
      onClick: onEdit,
      icon: faPen,
    });
  }

  actions.push({
    label: "View",
    onClick: onView,
    icon: faEye,
  });

  if (!readOnly) {
    actions.push({
      label: "Delete",
      onClick: onDelete,
      icon: faTrash,
    });
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          <FontAwesomeIcon icon={faCheck} />
          {documentTitle}
        </div>
        <span className={styles.description}>
          {type === AppealSupportingDocumentType.LetterOfMedicalNecessity
            ? letterOfMedicalNecessityDescription
            : documentDescription}
        </span>
      </div>
      <MeatballMenu actions={actions} />
    </div>
  );
};
